import CsvDownloader from "react-csv-downloader";
import ReactLoading from "react-loading";
import GrantReportFilters from "./Components/GrantReportFilters";
import GrantReportTable from "./Components/GrantReportTable";
import { useGrantReport } from "../../../../hooks/outorga/useGrantReport";

export default function GrantReport() {
    const {
        filters,
        setFilters,
        csv,
        reportData,
        generated,
        loading,
        generateReport,
        handleExportPDF,
        canGenerate
    } = useGrantReport();

    return (
        <div className="hdv-render-div">
            <div className="hdv-default-header mx-3">
                <span className="screen-menu-desc">
                    <h4>Relatório de Outorga</h4>
                    <div className="gray-background">
                        <i className="fa fa-file-alt fa-2x"></i>
                    </div>
                </span>

                <ReactLoading
                    type="cylon"
                    color={loading ? "var(--background-menu)" : "transparent"}
                    width={50}
                />
            </div>

            <GrantReportFilters filters={filters} onChange={setFilters} />

            <div className="hdv-btn-group">
                <button onClick={generateReport} disabled={!canGenerate() || loading} className="hdv-btn-forms hdv-btn-blue">
                    Gerar Relatório
                </button>

                <CsvDownloader
                    columns={csv.columns}
                    datas={csv.data}
                    filename="relatorio_outorga"
                >
                    <button disabled={!generated || loading || !reportData?.grants.length} className="hdv-btn-forms hdv-btn-green">Exportar CSV</button>
                </CsvDownloader>

                <button onClick={handleExportPDF} disabled={!generated || loading || !reportData?.grants.length} className="hdv-btn-forms hdv-btn-red">
                    Exportar PDF
                </button>
            </div>

            {generated && <GrantReportTable data={reportData?.grants} period={reportData?.period} />}
        </div>
    );
}